import { store } from "@/store"
import { signupWithRedirect } from "@/composables/useAccount.js"
import axios from "axios"

const manageGuard = ({ params: { id } }, from, next) => {
  store.dispatch("subscription/checkIfExists", id)
    .then(() => next())
    .catch(() => next("/"))
}

const signupGuard = () => signupWithRedirect()

const eligibilityGuard = async (to, from, next) => {
  try {
    await axios.get("/customer/subscriptions/eligibility")
    to.meta.canCreate = true
  }
  catch (error) {
    if (error.response && error.response.status === 403) {
      to.meta.canCreate = false
    }
    else {
      to.meta.canCreate = true
    }
  }
  next()
}

export {
  manageGuard,
  signupGuard,
  eligibilityGuard,
}
